import { VideoCameraIcon } from '@heroicons/react/24/solid';
import { useQuery } from '@tanstack/react-query';
import { getSignAssetsKey } from '../../../../api/assets';

export interface TrainingItemProps {
  name: string;
  description: string;
  s3_path: string;
}

const TrainingItem = ({ name, description, s3_path }: TrainingItemProps) => {
  //Tanstack: version 5 query implementation
  const fetchSignedVideoUrl = useQuery({ queryKey: [`get-${name}-signed-video-url`], queryFn: () => getSignAssetsKey({ key: s3_path }) });
  const signedVideoUrl = fetchSignedVideoUrl?.data?.url;

  return (
    <tr>
      <td className='p-4'>{name}</td>
      <td className='p-4'>{description}</td>
      <td className='p-4 text-primaryColor-normal hover:text-primaryColor-light cursor-pointer'>
        <a href={signedVideoUrl} target='_blank' rel='noreferrer' className='flex gap-2'>
          <VideoCameraIcon className='h-5 w-5' />
          Tutorial
        </a>
      </td>
    </tr>
  );
};

export default TrainingItem;
